export const docsHref = "https://docs.decodable.co";

export const communitySlack =
  "https://join.slack.com/t/decodablecommunity/shared_invite/zt-uvow71bk-Uf914umgpoyIbOQSxriJkA";

export const supportEmail = "mailto:support@decodable.co";
